
import param from '~/utils/url/param.js'

export default {
  name: 'social-reddit',
  props: {
    url: {
      type: String,
      async default() {
        return await window.location.href
      }
    },
    title: { type: String, default: '' }
  },
  methods: {
    open() {
      window.open(
        'https://reddit.com/submit' +
          param({ url: this.url, title: this.title }),
        '__blank'
      )
    }
  }
}
